import { v4 as uuidv4 } from 'uuid';
import { GAME_SYSTEM_NAMES } from '../registry';

const createElements = (definitions) =>
	definitions.map(({ key, label, role, systemMetadata }) => ({
		id: uuidv4(),
		key,
		label,
		i18nKey: `games.alien.${role}s.${key}`,
		role,
		systemMetadata,
	}));

export const createAlienTemplate = () => ({
	name: GAME_SYSTEM_NAMES.ALIEN,
	version: '1.0',
	gameSystem: GAME_SYSTEM_NAMES.ALIEN,
	isPublic: true,
	sections: [
		{
			id: 1,
			name: 'Identidad',
			type: 'text',
			elements: createElements([
				{ key: 'nombre', label: 'Nombre', role: 'identity' },
				{ key: 'profesion', label: 'Profesión', role: 'identity' },
				{ key: 'aspecto', label: 'Aspecto', role: 'identity' },
				{ key: 'motivacion', label: 'Motivación', role: 'identity' },
				{ key: 'colega', label: 'Colega', role: 'identity' },
				{ key: 'rival', label: 'Rival', role: 'identity' },
			]),
		},
		{
			id: 2,
			name: 'Fortaleza',
			type: 'number',
			elements: createElements([
				{ key: 'fortaleza', label: 'Fortaleza', role: 'attribute' },
				{
					key: 'combate_cuerpo_a_cuerpo',
					label: 'Combate cuerpo a cuerpo',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'fortaleza' },
				},
				{
					key: 'maquinaria_pesada',
					label: 'Maquinaria pesada',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'fortaleza' },
				},
				{
					key: 'aguante',
					label: 'Aguante',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'fortaleza' },
				},
			]),
		},
		{
			id: 3,
			name: 'Agilidad',
			type: 'number',
			elements: createElements([
				{
					key: 'agilidad',
					label: 'Agilidad',
					role: 'attribute',
				},
				{
					key: 'combate_a_distancia',
					label: 'Combate a distancia',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'agilidad' },
				},
				{
					key: 'movilidad',
					label: 'Movilidad',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'agilidad' },
				},
				{
					key: 'pilotar',
					label: 'Pilotar',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'agilidad' },
				},
			]),
		},
		{
			id: 4,
			name: 'Intelecto',
			type: 'number',
			elements: createElements([
				{
					key: 'intelecto',
					label: 'Intelecto',
					role: 'attribute',
				},
				{
					key: 'observacion',
					label: 'Observación',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'intelecto' },
				},
				{
					key: 'supervivencia',
					label: 'Supervivencia',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'intelecto' },
				},
				{
					key: 'computadoras',
					label: 'Computadoras',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'intelecto' },
				},
			]),
		},
		{
			id: 5,
			name: 'Empatía',
			type: 'number',
			elements: createElements([
				{
					key: 'empatia',
					label: 'Empatía',
					role: 'attribute',
				},
				{
					key: 'mando',
					label: 'Mando',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'empatia' },
				},
				{
					key: 'manipulacion',
					label: 'Manipulación',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'empatia' },
				},
				{
					key: 'medicina',
					label: 'Medicina',
					role: 'skill',
					systemMetadata: { linkedAttributeKey: 'empatia' },
				},
			]),
		},
		{
			id: 6,
			name: 'Recursos',
			type: 'counter',
			elements: [
				{
					id: uuidv4(),
					key: 'nivel_de_tension',
					label: 'Nivel de tensión',
					i18nKey: 'games.alien.resources.nivel_de_tension',
					role: 'resource',
					systemMetadata: { feedsDiceSystem: 'alienStress' },
					value: {
						value: 0,
						min: 0,
						max: 10,
						defaultValue: 0,
						triggers: [],
					},
				},
				{
					id: uuidv4(),
					key: 'vitalidad',
					label: 'Vitalidad',
					i18nKey: 'games.alien.resources.vitalidad',
					role: 'resource',
					value: {
						value: 0,
						min: 0,
						max: 10,
						defaultValue: 0,
						triggers: [],
					},
				},
				{
					id: uuidv4(),
					key: 'radiacion',
					label: 'Radiación',
					i18nKey: 'games.alien.resources.radiacion',
					role: 'resource',
					value: {
						value: 0,
						min: 0,
						max: 8,
						defaultValue: 0,
						triggers: [],
					},
				},
				{
					id: uuidv4(),
					key: 'puntos_de_experiencia',
					label: 'Puntos de experiencia',
					i18nKey: 'games.alien.resources.puntos_de_experiencia',
					role: 'resource',
					value: {
						value: 0,
						min: 0,
						max: 10,
						defaultValue: 0,
						triggers: [],
					},
				},
				{
					id: uuidv4(),
					key: 'puntos_de_trama',
					label: 'Puntos de trama',
					i18nKey: 'games.alien.resources.puntos_de_trama',
					role: 'resource',
					value: {
						value: 0,
						min: 0,
						max: 3,
						defaultValue: 0,
						triggers: [],
					},
				},
			],
		},
		{
			id: 7,
			name: 'Suministros',
			type: 'number',
			elements: createElements([
				{ key: 'aire', label: 'Aire', role: 'resource' },
				{ key: 'comida', label: 'Comida', role: 'resource' },
				{ key: 'energia', label: 'Energía', role: 'resource' },
				{ key: 'agua', label: 'Agua', role: 'resource' },
			]),
		},
		{
			id: 8,
			name: 'Notas y equipo',
			type: 'textarea',
			elements: createElements([
				{ key: 'talentos', label: 'Talentos', role: 'notes' },
				{ key: 'objeto_personal', label: 'Objeto personal', role: 'notes' },
				{ key: 'objetos_diminutos', label: 'Objetos diminutos', role: 'notes' },
				{ key: 'equipo', label: 'Equipo', role: 'notes' },
				{ key: 'blindaje', label: 'Blindaje', role: 'notes' },
				{ key: 'armas', label: 'Armas', role: 'notes' },
				{ key: 'capacidad_de_carga', label: 'Capacidad de carga', role: 'notes' },
				{ key: 'heridas_criticas', label: 'Heridas críticas', role: 'notes' },
				{ key: 'estados', label: 'Estados', role: 'notes' },
			]),
		},
	],
});

export default createAlienTemplate;
